import React, { Component } from 'react';
import { Modal, Row, Col, Container, Table } from 'react-bootstrap';


class AttendanceReportModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1,
    };
    this.pageSize = 10;
  }

  // Reset to the first page whenever the modal is (re)opened.
  componentDidUpdate(prevProps) {
    if (this.props.show && !prevProps.show && this.state.currentPage !== 1) {
      this.setState({ currentPage: 1 });
    }
  }

  render() {

    console.log("llllllllllllllllll", this.props)

    let roomWiseData = this.props.stateData.roomWiseData;

    let data = [];

    let uniqueStudents = [...new Set(roomWiseData?.map((item) => item.edu_student_id))];

    console.log("uniqueStudents", uniqueStudents, roomWiseData);


    uniqueStudents.map((item) => {
      // Skip empty beds and allocations for deleted/unknown students — show only
      // bed-allocated students that resolve to a real name.
      if (!item) return;
      let studentName = (this.props.allStudents || []).find((s) => s.student_id == item)
        || this.props.getNewEducationalStudents.find((item1) => item1.student_id == item);
      if (!studentName || !studentName.student_name) return;
      let presentData = roomWiseData.filter((item2) => item2.edu_student_id == item).filter((item3) => item3.attendance_status == 1 && item3.attended_date != null).length
      let dateWiseAttendance = [];



      this.props.stateData.dateArrayfinal.map((date) => {
        let eachDateWise = roomWiseData.filter((item2) => item2.edu_student_id == item).filter((item3) => item3.attended_date == date.unixDate);
        console.log("eachDateWise", eachDateWise);
        if (eachDateWise.length > 0) {
          if (eachDateWise[0].attendance_status == 0) {
            dateWiseAttendance.push("A")
          } else {
            dateWiseAttendance.push("P")
          }

        } else {
          dateWiseAttendance.push("-")
        }

      })
      data.push({ studentName: studentName.student_name, rollNo: studentName.roll_no, presentCount: presentData, totalDays: this.props.stateData.dateArrayfinal.length, dateWiseAttendance: dateWiseAttendance })
    })


    console.log("data", data);

    // ── Pagination ──
    const pageSize = this.pageSize;
    const totalPages = Math.ceil(data.length / pageSize);
    const currentPage = Math.min(this.state.currentPage, totalPages || 1);
    const startIndex = (currentPage - 1) * pageSize;
    const pagedData = data.slice(startIndex, startIndex + pageSize);

    const th = { fontSize: 11, fontWeight: 700, color: "#fff", textTransform: "uppercase", letterSpacing: "0.4px", padding: "10px 12px", textAlign: "center", background: "#334155", whiteSpace: "nowrap", borderBottom: "none" };
    const td = { fontSize: 13, color: "#1f2937", padding: "9px 12px", borderBottom: "1px solid #f1f5f9", textAlign: "center", verticalAlign: "middle", whiteSpace: "nowrap" };
    const chip = (bg, color, border) => ({ display: "inline-flex", alignItems: "center", justifyContent: "center", minWidth: 26, height: 24, borderRadius: 7, fontSize: 12, fontWeight: 700, background: bg, color, border: `1px solid ${border}` });

    const statusCell = (st) => {
      if (st === "P") return <span style={chip("#dcfce7", "#15803d", "#bbf7d0")}>P</span>;
      if (st === "A") return <span style={chip("#fee2e2", "#dc2626", "#fecaca")}>A</span>;
      return <span style={{ color: "#cbd5e1", fontWeight: 700 }}>—</span>;
    };

    return (
      <Modal {...this.props} dialogClassName="bc-modal-wide" aria-labelledby="contained-modal-title-vcenter" centered>
        <div style={{ background: "#fff", borderRadius: 12, overflow: "hidden" }}>
          <Modal.Header style={{ background: "linear-gradient(135deg, #6366f1 0%, #4f46e5 100%)", borderBottom: "none", padding: "16px 22px" }}>
            <Modal.Title style={{ display: "flex", alignItems: "center", gap: 12, width: "100%", margin: 0 }}>
              <span style={{ width: 38, height: 38, borderRadius: 10, background: "rgba(255,255,255,0.18)", display: "inline-flex", alignItems: "center", justifyContent: "center", color: "#fff" }}><i className="fal fa-clipboard-check" /></span>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <span style={{ fontSize: 17, fontWeight: 700, color: "#fff", lineHeight: 1.2 }}>Room Wise Attendance</span>
                <span style={{ fontSize: 12, fontWeight: 500, color: "rgba(255,255,255,0.85)", marginTop: 2 }}>Day-wise attendance for each allocated student</span>
              </div>
              <button type="button" aria-label="Close" onClick={this.props.onHide} style={{ marginLeft: "auto", width: 32, height: 32, borderRadius: "50%", border: "none", background: "rgba(255,255,255,0.2)", color: "#fff", fontSize: 20, lineHeight: 1, cursor: "pointer" }}>&times;</button>
            </Modal.Title>
          </Modal.Header>

          <Modal.Body style={{ padding: "18px 20px", background: "#fff" }}>
            {this.props.stateData.loader == 1 ? (
              <div className="text-center" style={{ padding: "40px 0" }}><div className="spinner-border text-primary"></div></div>
            ) : data.length > 0 ? (
              <>
                {/* Legend */}
                <div style={{ display: "flex", gap: 14, flexWrap: "wrap", marginBottom: 14, fontSize: 12, color: "#64748b" }}>
                  <span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}><span style={chip("#dcfce7", "#15803d", "#bbf7d0")}>P</span> Present</span>
                  <span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}><span style={chip("#fee2e2", "#dc2626", "#fecaca")}>A</span> Absent</span>
                  <span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}><span style={{ color: "#cbd5e1", fontWeight: 700 }}>—</span> Not marked</span>
                </div>

                <div style={{ border: "1px solid #e2e8f0", borderRadius: 12, overflow: "hidden" }}>
                  <div style={{ overflowX: "auto", maxHeight: 460 }}>
                    <table style={{ width: "100%", borderCollapse: "collapse" }}>
                      <thead>
                        <tr>
                          <th style={{ ...th, position: "sticky", left: 0, zIndex: 3 }}>#</th>
                          <th style={{ ...th, textAlign: "left", position: "sticky", left: 40, zIndex: 3 }}>Student</th>
                          <th style={th}>Present</th>
                          {this.props.stateData.dateArrayfinal.map((d, i) => (
                            <th key={i} style={th}>{d.date}</th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {pagedData.map((item, i) => {
                          const index = startIndex + i;
                          const pct = item.totalDays > 0 ? item.presentCount / item.totalDays : 0;
                          const presentColor = pct >= 0.75 ? { bg: "#dcfce7", c: "#15803d", b: "#bbf7d0" } : pct > 0 ? { bg: "#fef9c3", c: "#a16207", b: "#fde68a" } : { bg: "#f1f5f9", c: "#64748b", b: "#e2e8f0" };
                          return (
                            <tr key={index} style={{ background: index % 2 === 0 ? "#fff" : "#fbfcfe" }}>
                              <td style={{ ...td, color: "#94a3b8", fontWeight: 600, position: "sticky", left: 0, background: "inherit" }}>{index + 1}</td>
                              <td style={{ ...td, textAlign: "left", position: "sticky", left: 40, background: "inherit" }}>
                                <div style={{ fontWeight: 600, color: "#0f172a" }}>{item.studentName}</div>
                                {item.rollNo ? <div style={{ fontSize: 11, color: "#94a3b8" }}>Roll No: {item.rollNo}</div> : null}
                              </td>
                              <td style={td}>
                                <span style={chip(presentColor.bg, presentColor.c, presentColor.b)}>{item.presentCount} / {item.totalDays}</span>
                              </td>
                              {item.dateWiseAttendance.map((st, i) => (
                                <td key={i} style={td}>{statusCell(st)}</td>
                              ))}
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>

                {totalPages > 1 && (
                  <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: 6, flexWrap: "wrap", marginTop: 14 }}>
                    <span style={{ fontSize: 12, color: "#94a3b8", marginRight: 6 }}>
                      Showing {startIndex + 1}-{Math.min(startIndex + pageSize, data.length)} of {data.length}
                    </span>
                    {Array.from({ length: totalPages }, (_, index) => {
                      const active = currentPage === index + 1;
                      return (
                        <button key={index} onClick={() => this.setState({ currentPage: index + 1 })}
                          style={{ border: active ? "1.5px solid #6366f1" : "1.5px solid #e5e7eb", background: active ? "#6366f1" : "#fff", color: active ? "#fff" : "#374151", borderRadius: 8, padding: "5px 11px", cursor: "pointer", fontSize: 13, fontWeight: active ? 700 : 500, minWidth: 34 }}>
                          {index + 1}
                        </button>
                      );
                    })}
                  </div>
                )}
              </>
            ) : (
              <div style={{ textAlign: "center", padding: "48px 0", color: "#94a3b8" }}>
                <i className="fal fa-clipboard" style={{ fontSize: 34, marginBottom: 10 }} />
                <h6 style={{ color: "#64748b", margin: 0 }}>No attendance data available</h6>
              </div>
            )}
          </Modal.Body>
        </div>
      </Modal >
    )
  }
}

export default AttendanceReportModal;
